import { geojson } from "flatgeobuf";
import { bbox, pointsWithinPolygon, getCoords, polygon } from '@turf/turf';

export const loadFGB = async (fgb_srcs, boundary, setCount) => {

  // const box = bbox(boundary);
  
  console.log("fgb_srcs", fgb_srcs);
  console.log("boundary", boundary)
  const boundingBoxes = getBoundingBoxesFromBoundary(boundary);
  const allResults = [];
  
  for (const box of boundingBoxes) {
    const bounds = {
      maxX: box[2],
      maxY: box[3],
      minX: box[0],
      minY: box[1],
    };

    for await (var fgb_src of fgb_srcs) {
      const iter = geojson.deserialize(
        fgb_src, bounds,
        (meta) => { console.log(meta); });

      const results = [];
      for await (let f of iter) {
        results.push(f);
        // update counter every 977 results to look random
        if (results.length % 977 === 12) {
          setCount(allResults.length + results.length);
        }
      }
      allResults.push(...results);
    }
  }
  console.log("total retrieval", allResults.length);
  setCount(allResults.length);

  const res = {
    'type': 'FeatureCollection',
    'features': allResults
  }
  const pointsWithin = pointsWithinPolygon(res, boundary);
  setCount(pointsWithin.features.length);
  return summarize(pointsWithin.features) 
}

const summarize = (features) => {
  const counts = {};
  let totalCount = 0;

  for (let i = 0; i < features.length; ++i) {
    const feature = features[i];
    const cnt = feature.properties.cnt_total;
    totalCount += cnt;

    if (feature.properties.gene_name in counts) {
      counts[feature.properties.gene_name] += cnt;
    } else {
      counts[feature.properties.gene_name] = cnt;
    }
  }
  return {
    sge: features,
    totalCount: totalCount,
    countByGene: counts
  }
}

export const getBoundingBoxesFromBoundary = (boundary) => {
  const multiPolygonCoords = getCoords(boundary);
  return multiPolygonCoords.map(polygonCoords => {
    const poly = polygon(polygonCoords);
    return bbox(poly);
  });
};
